__turbopack_context__.v({
  "className": "plus_jakarta_sans_2b40c2e4-module__yBzT9q__className",
  "variable": "plus_jakarta_sans_2b40c2e4-module__yBzT9q__variable",
});
